import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'


function Footer() {
    return (
        <React.Fragment>
            <footer>
                <div class="row align-items-start">
                    <div className="col">
                        <h4> Quick Links </h4>
                        <ul>
                            <li> <Link to='/'> Home </Link> </li>
                            <li> <Link to='/expertise'> Expertise </Link> </li>
                            <li> <Link to='/services'> Services </Link> </li>
                            <li> <Link to='/projects'> Projects </Link> </li>
                            <li> <Link to='/about-us'> About Us </Link> </li>
                            <li> <Link to='/contact'> Contact </Link> </li>
                        </ul>
                    </div>
                    <div className="col">
                        <h4> Contact Information </h4>
                        <ul>
                            <li> <a href='tel: +16048319276'> +1 (604) 831-9276 </a> </li>
                            <li> <a href='mailto: info@cmoconsultants.ca'> info@cmoconsultants.ca </a> </li>
                            <li> <a href='https://maps.app.goo.gl/5NnPBsw1gvX4yaUt5'> 300 – 1 West 7th Avenue <br /> Vancouver, BC  V5Y 1L4 </a> </li>
                        </ul>
                    </div>
                    {/* <div className="col"></div> */}
                </div>
                <hr />
                <div className='copyright-text text-center'>
                    &copy; 2025 CMO Consultants Ltd. All rights reserved.
                </div>
            </footer>
        </React.Fragment>
    )
}

export default Footer;
